/**
 * "Save my team for next time": the last step's opt-in that turns a coach
 * without a TourneyNation account (a guest, or a new email) into one after
 * payment (useAccountPromotion). Shown only to such coaches; checked by
 * default (FlowContext.createAccount).
 */
import '../pages/ConfirmPage.css';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function SaveTeamOption({ checked, onChange }: Props) {
  return (
    <label className="tn-confirm__account-opt">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <span className="tn-confirm__account-opt-body">
        <span className="tn-confirm__account-opt-title">Save my team for next time</span>
        <span className="tn-confirm__account-opt-text">
          Sets up a TourneyNation account with this email to keep your team and
          registrations. Manage it on{' '}
          <a href="https://tourneynation.com" target="_blank" rel="noopener noreferrer">tourneynation.com</a>.
        </span>
      </span>
    </label>
  );
}
